function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';
import { colors as colorsOrange } from '../themes/orange';

var px2rem = function px2rem(px) {
  return px / 16 + "rem";
};

var font = function font(props) {
  return {
    fontFamily: props.fontFamily,
    fontWeight: props.fontWeight,
    fontSize: props.fontSize !== undefined && px2rem(props.fontSize),
    lineHeight: props.lineHeight !== undefined && px2rem(props.lineHeight)
  };
};

var size = function size(props) {
  return {
    width: props.width !== undefined && (typeof props.width === 'string' ? props.width : px2rem(props.width)),
    height: props.height !== undefined && (typeof props.height === 'string' ? props.height : px2rem(props.height))
  };
};

var margin = function margin(props) {
  return {
    margin: px2rem(props.marginTop || 0) + " " + px2rem(props.marginRight || 0) + " " + px2rem(props.marginBottom || 0) + " " + px2rem(props.marginLeft || 0)
  };
};

var padding = function padding(props) {
  return {
    padding: px2rem(props.paddingTop || 0) + " " + px2rem(props.paddingRight || 0) + " " + px2rem(props.paddingBottom || 0) + " " + px2rem(props.paddingLeft || 0)
  };
};

var getDisplay = function getDisplay(props) {
  var theme = props.theme;
  var breakpoints = theme.breakpoints;
  var obj = {};

  if (typeof props.display === 'string') {
    obj.display = props.display;
  } else if (typeof props.display === 'object') {
    obj.display = props.display.xs;
    obj["@media (min-width: " + breakpoints.small + "px)"] = {
      display: props.display.s
    };
    obj["@media (min-width: " + breakpoints.medium + "px)"] = {
      display: props.display.m
    };
    obj["@media (min-width: " + breakpoints.large + "px)"] = {
      display: props.display.l
    };
    obj["@media (min-width: " + breakpoints.xlarge + "px)"] = {
      display: props.display.xl
    };
    obj["@media (min-width: " + breakpoints.xxlarge + "px)"] = {
      display: props.display.xxl
    };
  }

  return obj;
};

var getMarginValue = function getMarginValue(value) {
  if (typeof value === 'number') {
    return px2rem(value * 15);
  } else if (value === 'auto') {
    return value;
  }

  return undefined;
};

var getPaddingValue = function getPaddingValue(value) {
  if (typeof value === 'number') {
    return px2rem(value * 15);
  }

  return undefined;
};

var getSpacing = function getSpacing(props) {
  var theme = props.theme;
  var breakpoints = theme.breakpoints;
  var spacing = {};
  spacing["@media (min-width: " + breakpoints.small + "px)"] = {};
  spacing["@media (min-width: " + breakpoints.medium + "px)"] = {};
  spacing["@media (min-width: " + breakpoints.large + "px)"] = {};
  spacing["@media (min-width: " + breakpoints.xlarge + "px)"] = {};
  spacing["@media (min-width: " + breakpoints.xxlarge + "px)"] = {}; // margin-top

  if (typeof props.mt === 'number') {
    spacing.marginTop = px2rem(props.mt * 15);
  } else if (props.mt === 'auto') {
    spacing.marginTop = 'auto';
  } else if (typeof props.mt === 'object') {
    spacing.marginTop = getMarginValue(props.mt.xs);
    spacing["@media (min-width: " + breakpoints.small + "px)"].marginTop = getMarginValue(props.mt.s);
    spacing["@media (min-width: " + breakpoints.medium + "px)"].marginTop = getMarginValue(props.mt.m);
    spacing["@media (min-width: " + breakpoints.large + "px)"].marginTop = getMarginValue(props.mt.l);
    spacing["@media (min-width: " + breakpoints.xlarge + "px)"].marginTop = getMarginValue(props.mt.xl);
    spacing["@media (min-width: " + breakpoints.xxlarge + "px)"].marginTop = getMarginValue(props.mt.xxl);
  } // margin-right


  if (typeof props.mr === 'number') {
    spacing.marginRight = px2rem(props.mr * 15);
  } else if (props.mr === 'auto') {
    spacing.marginRight = 'auto';
  } else if (typeof props.mr === 'object') {
    spacing.marginRight = getMarginValue(props.mr.xs);
    spacing["@media (min-width: " + breakpoints.small + "px)"].marginRight = getMarginValue(props.mr.s);
    spacing["@media (min-width: " + breakpoints.medium + "px)"].marginRight = getMarginValue(props.mr.m);
    spacing["@media (min-width: " + breakpoints.large + "px)"].marginRight = getMarginValue(props.mr.l);
    spacing["@media (min-width: " + breakpoints.xlarge + "px)"].marginRight = getMarginValue(props.mr.xl);
    spacing["@media (min-width: " + breakpoints.xxlarge + "px)"].marginRight = getMarginValue(props.mr.xxl);
  } // margin-bottom


  if (typeof props.mb === 'number') {
    spacing.marginBottom = px2rem(props.mb * 15);
  } else if (props.mb === 'auto') {
    spacing.marginBottom = 'auto';
  } else if (typeof props.mb === 'object') {
    spacing.marginBottom = getMarginValue(props.mb.xs);
    spacing["@media (min-width: " + breakpoints.small + "px)"].marginBottom = getMarginValue(props.mb.s);
    spacing["@media (min-width: " + breakpoints.medium + "px)"].marginBottom = getMarginValue(props.mb.m);
    spacing["@media (min-width: " + breakpoints.large + "px)"].marginBottom = getMarginValue(props.mb.l);
    spacing["@media (min-width: " + breakpoints.xlarge + "px)"].marginBottom = getMarginValue(props.mb.xl);
    spacing["@media (min-width: " + breakpoints.xxlarge + "px)"].marginBottom = getMarginValue(props.mb.xxl);
  } // margin-left


  if (typeof props.ml === 'number') {
    spacing.marginLeft = px2rem(props.ml * 15);
  } else if (props.ml === 'auto') {
    spacing.marginLeft = 'auto';
  } else if (typeof props.ml === 'object') {
    spacing.marginLeft = getMarginValue(props.ml.xs);
    spacing["@media (min-width: " + breakpoints.small + "px)"].marginLeft = getMarginValue(props.ml.s);
    spacing["@media (min-width: " + breakpoints.medium + "px)"].marginLeft = getMarginValue(props.ml.m);
    spacing["@media (min-width: " + breakpoints.large + "px)"].marginLeft = getMarginValue(props.ml.l);
    spacing["@media (min-width: " + breakpoints.xlarge + "px)"].marginLeft = getMarginValue(props.ml.xl);
    spacing["@media (min-width: " + breakpoints.xxlarge + "px)"].marginLeft = getMarginValue(props.ml.xxl);
  } // padding-top


  if (typeof props.pt === 'number') {
    spacing.paddingTop = px2rem(props.pt * 15);
  } else if (typeof props.pt === 'object') {
    spacing.paddingTop = getPaddingValue(props.pt.xs);
    spacing["@media (min-width: " + breakpoints.small + "px)"].paddingTop = getPaddingValue(props.pt.s);
    spacing["@media (min-width: " + breakpoints.medium + "px)"].paddingTop = getPaddingValue(props.pt.m);
    spacing["@media (min-width: " + breakpoints.large + "px)"].paddingTop = getPaddingValue(props.pt.l);
    spacing["@media (min-width: " + breakpoints.xlarge + "px)"].paddingTop = getPaddingValue(props.pt.xl);
    spacing["@media (min-width: " + breakpoints.xxlarge + "px)"].paddingTop = getPaddingValue(props.pt.xxl);
  } // padding-right


  if (typeof props.pr === 'number') {
    spacing.paddingRight = px2rem(props.pr * 15);
  } else if (typeof props.pr === 'object') {
    spacing.paddingRight = getPaddingValue(props.pr.xs);
    spacing["@media (min-width: " + breakpoints.small + "px)"].paddingRight = getPaddingValue(props.pr.s);
    spacing["@media (min-width: " + breakpoints.medium + "px)"].paddingRight = getPaddingValue(props.pr.m);
    spacing["@media (min-width: " + breakpoints.large + "px)"].paddingRight = getPaddingValue(props.pr.l);
    spacing["@media (min-width: " + breakpoints.xlarge + "px)"].paddingRight = getPaddingValue(props.pr.xl);
    spacing["@media (min-width: " + breakpoints.xxlarge + "px)"].paddingRight = getPaddingValue(props.pr.xxl);
  } // padding-bottom


  if (typeof props.pb === 'number') {
    spacing.paddingBottom = px2rem(props.pb * 15);
  } else if (typeof props.pb === 'object') {
    spacing.paddingBottom = getPaddingValue(props.pb.xs);
    spacing["@media (min-width: " + breakpoints.small + "px)"].paddingBottom = getPaddingValue(props.pb.s);
    spacing["@media (min-width: " + breakpoints.medium + "px)"].paddingBottom = getPaddingValue(props.pb.m);
    spacing["@media (min-width: " + breakpoints.large + "px)"].paddingBottom = getPaddingValue(props.pb.l);
    spacing["@media (min-width: " + breakpoints.xlarge + "px)"].paddingBottom = getPaddingValue(props.pb.xl);
    spacing["@media (min-width: " + breakpoints.xxlarge + "px)"].paddingBottom = getPaddingValue(props.pb.xxl);
  } // padding-left


  if (typeof props.pl === 'number') {
    spacing.paddingLeft = px2rem(props.pl * 15);
  } else if (typeof props.pl === 'object') {
    spacing.paddingLeft = getPaddingValue(props.pl.xs);
    spacing["@media (min-width: " + breakpoints.small + "px)"].paddingLeft = getPaddingValue(props.pl.s);
    spacing["@media (min-width: " + breakpoints.medium + "px)"].paddingLeft = getPaddingValue(props.pl.m);
    spacing["@media (min-width: " + breakpoints.large + "px)"].paddingLeft = getPaddingValue(props.pl.l);
    spacing["@media (min-width: " + breakpoints.xlarge + "px)"].paddingLeft = getPaddingValue(props.pl.xl);
    spacing["@media (min-width: " + breakpoints.xxlarge + "px)"].paddingLeft = getPaddingValue(props.pl.xxl);
  }

  return spacing;
};

var createSvgIcon = function createSvgIcon(iconObj) {
  var Icon = function Icon(props) {
    var theme = props.theme,
        iconSize = props.size,
        color = props.color,
        rest = _objectWithoutPropertiesLoose(props, ["theme", "size", "color"]);

    var colors = theme.colors;
    return /*#__PURE__*/React.createElement("svg", _extends({
      width: iconSize,
      height: iconSize,
      viewBox: "0 0 " + iconObj.width + " " + iconObj.height
    }, rest), iconObj.paths.map(function (p, key) {
      return /*#__PURE__*/React.createElement("path", {
        key: key,
        d: p,
        fill: colors[color]
      });
    }));
  };

  Icon.displayName = iconObj.name;
  Icon.propTypes = process.env.NODE_ENV !== "production" ? {
    theme: PropTypes.shape({
      colors: PropTypes.shape({}).isRequired
    }),
    size: PropTypes.number,
    color: PropTypes.string
  } : {};
  Icon.defaultProps = {
    theme: {
      colors: colorsOrange
    },
    size: 32,
    color: 'black'
  };
  return withTheme(Icon);
};

var setInputValue = function setInputValue(inputElement, value) {
  var setValue = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
  setValue.call(inputElement, value);
  var event;

  if (typeof Event === 'function') {
    event = new Event('input', {
      bubbles: true
    });
  } else {
    // for IE11
    event = document.createEvent('Event');
    event.initEvent('input', true, false);
  }

  inputElement.dispatchEvent(event);
};

var ScrollableContainer = styled.div(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  var colors = theme.colors;
  return {
    overflow: 'auto',
    '::-webkit-scrollbar': {
      width: px2rem(10)
    },
    '::-webkit-scrollbar-thumb': {
      background: colors.grey4
    },
    '::-webkit-scrollbar-track': {
      background: colors.white
    }
  };
});

var mediaMinWidth = function mediaMinWidth(minWidth) {
  return "@media (min-width: " + minWidth + "px)";
};

export { px2rem, font, size, margin, padding, getSpacing, getDisplay, createSvgIcon, setInputValue, ScrollableContainer, mediaMinWidth };